// extracted by mini-css-extract-plugin
module.exports = {"container":"NewBorrowerForm_container__2J-Al","borrowerTypeButtonToggleGroup":"NewBorrowerForm_borrowerTypeButtonToggleGroup__IW8q7"};